import React, { useState, useEffect, useCallback } from 'react';
import '../fonts.css';
import API_BASE_URL from '../api';

const QA = ({ refreshQAData }) => {
  const [qaData, setQaData] = useState([]);
  const [globalEdit, setGlobalEdit] = useState(false);
  const [editTexts, setEditTexts] = useState({});

  const getAuthToken = () => localStorage.getItem('stack_access_token');

  const fetchData = useCallback(async () => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/qa`, {
      method: 'GET',
      headers: {
        'X-Stack-Access-Token': token,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      console.error('Failed to fetch QA data');
      return;
    }
    const data = await response.json();
    setQaData(data);
    const initialEditTexts = data.reduce((acc, item) => {
      item.answers.forEach((answer) => {
        acc[answer.answers_id] = answer.answer;
      });
      return acc;
    }, {});
    setEditTexts(initialEditTexts);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleEditTextChange = (answerId, newText) => {
    const updatedText = newText.trim() || 'No preferences set.';
    setEditTexts((prev) => ({ ...prev, [answerId]: updatedText }));
  };

  const handleSaveAll = async () => {
    const token = getAuthToken();
    await Promise.all(
      Object.entries(editTexts).map(async ([answerId, answerText]) => {
        const questionId = qaData.find((q) =>
          q.answers.some((a) => a.answers_id.toString() === answerId),
        ).question_id;
        await fetch(`${API_BASE_URL}/api/qa/edit`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Stack-Access-Token': token,
          },
          body: JSON.stringify({
            question_id: questionId,
            answers_id: answerId,
            answer_text: answerText,
          }),
        });
      }),
    );
    setGlobalEdit(false); // Exit edit mode
    fetchData(); // Refresh data
  };

  return (
    <div className="bg-bggreen">
      <div
        className="max-w-md w-full mx-auto p-8 rounded-lg shadow-md"
        style={{ backgroundColor: '#05664f' }}
      >
        <h2
          className="text-4xl font-bold text-white text-center mb-6"
          style={{ fontFamily: 'Inter', textTransform: 'uppercase' }}
        >
          Questions & Answers
        </h2>
        <div className="flex justify-end space-x-4 mb-6">
          {globalEdit ? (
            <button
              onClick={handleSaveAll}
              className="w-25 justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              style={{ backgroundColor: '#000000' }}
            >
              SAVE
            </button>
          ) : (
            <button
              onClick={() => setGlobalEdit(true)}
              className="w-25 justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              style={{ backgroundColor: '#000000' }}
            >
              EDIT
            </button>
          )}
        </div>
        {qaData.map((item) => (
          <div key={item.question_id} className="mb-4">
            <h3 className="font-bold text-white">{item.question}</h3>
            <ul className="list-disc pl-5">
              {item.answers.map((answer) => (
                <li key={answer.answers_id} className="text-white mt-1">
                  {globalEdit ? (
                    <input
                      type="text"
                      value={
                        (editTexts[answer.answers_id] ===
                          'No preferences set.' ||
                          editTexts[answer.answers_id] === '') &&
                        globalEdit
                          ? ''
                          : editTexts[answer.answers_id]
                      }
                      placeholder={
                        (editTexts[answer.answers_id] ===
                          'No preferences set.' ||
                          editTexts[answer.answers_id] === '') &&
                        globalEdit
                          ? 'Please fill in your answers here.'
                          : ''
                      }
                      onChange={(e) =>
                        handleEditTextChange(answer.answers_id, e.target.value)
                      }
                      style={{ color: '#0d2329' }}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
                    />
                  ) : (
                    <span>{answer.answer}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QA;
